// extracted by mini-css-extract-plugin
export default {"collapse":"Collapse_collapse__M7CPg"};